import React, { useState } from 'react';
import DashboardLayout from "../layouts/DashboardLayout";
import { grantRice, grantRiceForAll, revokeRice } from "../../api/AdminApi";

const RiceGrantAndRevokeManagementPage = () => {
    // 단일 멤버 쌀 지급
    const [singleGrantMemberId, setSingleGrantMemberId] = useState('');
    const [singleGrantAmount, setSingleGrantAmount] = useState('');

    // 전체 멤버 쌀 지급
    const [allGrantAmount, setAllGrantAmount] = useState('');

    // 단일 멤버 쌀 회수
    const [singleRevokeMemberId, setSingleRevokeMemberId] = useState('');
    const [singleRevokeAmount, setSingleRevokeAmount] = useState('');

    const handleSingleGrant = async () => {
        if (!singleGrantMemberId || !singleGrantAmount) {
            alert('멤버 ID와 지급할 쌀 수량은 필수입니다.');
            return;
        }

        const amount = parseInt(singleGrantAmount);
        if (isNaN(amount) || amount <= 0) {
            alert('지급할 쌀 수량은 양수여야 합니다.');
            return;
        }

        const confirmed = window.confirm(`멤버 ID ${singleGrantMemberId}에게 쌀 ${amount}알을 지급하시겠습니까?`);
        if (!confirmed) return;

        try {
            await grantRice(singleGrantMemberId, amount);
            alert('쌀 지급이 완료되었습니다.');
            setSingleGrantMemberId('');
            setSingleGrantAmount('');
        } catch (error) {
            console.error('단일 멤버 쌀 지급 실패:', error);
            alert('쌀 지급에 실패했습니다.');
        }
    };

    const handleAllGrant = async () => {
        if (!allGrantAmount) {
            alert('지급할 쌀 수량은 필수입니다.');
            return;
        }

        const amount = parseInt(allGrantAmount);
        if (isNaN(amount) || amount <= 0) {
            alert('지급할 쌀 수량은 양수여야 합니다.');
            return;
        }

        const confirmed = window.confirm(`전체 멤버에게 쌀 ${amount}알을 지급하시겠습니까?`);
        if (!confirmed) return;

        try {
            await grantRiceForAll(amount);
            alert('전체 멤버에게 쌀 지급이 완료되었습니다.');
            setAllGrantAmount('');
        } catch (error) {
            console.error('전체 멤버 쌀 지급 실패:', error);
            alert('쌀 지급에 실패했습니다.');
        }
    };

    const handleSingleRevoke = async () => {
        if (!singleRevokeMemberId || !singleRevokeAmount) {
            alert('멤버 ID와 회수할 쌀 수량은 필수입니다.');
            return;
        }

        const amount = parseInt(singleRevokeAmount);
        if (isNaN(amount) || amount <= 0) {
            alert('회수할 쌀 수량은 양수여야 합니다.');
            return;
        }

        const confirmed = window.confirm(`멤버 ID ${singleRevokeMemberId}로부터 쌀 ${amount}알을 회수하시겠습니까?`);
        if (!confirmed) return;

        try {
            await revokeRice(singleRevokeMemberId, amount);
            alert('쌀 회수가 완료되었습니다.');
            setSingleRevokeMemberId('');
            setSingleRevokeAmount('');
        } catch (error) {
            console.error('단일 멤버 쌀 회수 실패:', error);
            alert('쌀 회수에 실패했습니다. 멤버 ID 존재여부나 해당 멤버의 쌀 잔액을 확인해 주세요.');
        }
    };

    return (
        <DashboardLayout>
            <div className="p-3">
                <h1 className="text-lg font-bold mb-3">쌀 지급 및 회수 관리</h1>
                
                <div className="w-1/2">
                    {/* 단일 멤버 쌀 지급 */}
                    <div className="bg-gray-100 border border-gray-300 p-2 mb-3">
                        <h2 className="text-xs font-bold mb-2">단일 멤버 쌀 지급</h2>
                        <table className="w-full text-xs">
                            <tbody>
                                <tr>
                                    <td className="w-16 py-1">멤버 ID</td>
                                    <td className="py-1">
                                        <input 
                                            type="number" 
                                            value={singleGrantMemberId}
                                            onChange={(e) => setSingleGrantMemberId(e.target.value)}
                                            className="w-full border border-gray-300 px-1 py-1"
                                            placeholder="멤버 ID 입력"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="py-1">지급액</td>
                                    <td className="py-1">
                                        <input 
                                            type="number" 
                                            value={singleGrantAmount}
                                            onChange={(e) => setSingleGrantAmount(e.target.value)}
                                            className="w-full border border-gray-300 px-1 py-1"
                                            placeholder="지급액"
                                            min="1"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td className="py-1">
                                        <button 
                                            onClick={handleSingleGrant}
                                            className="px-2 py-1 bg-gray-200 border border-gray-300 hover:bg-gray-300 text-xs"
                                        >
                                            지급
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* 전체 멤버 쌀 지급 */}
                    <div className="bg-gray-100 border border-gray-300 p-2 mb-3">
                        <h2 className="text-xs font-bold mb-2">전체 멤버 쌀 지급</h2>
                        <table className="w-full text-xs">
                            <tbody>
                                <tr>
                                    <td className="w-16 py-1">지급액</td>
                                    <td className="py-1">
                                        <input 
                                            type="number" 
                                            value={allGrantAmount}
                                            onChange={(e) => setAllGrantAmount(e.target.value)}
                                            className="w-full border border-gray-300 px-1 py-1"
                                            placeholder="지급액"
                                            min="1"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td className="py-1">
                                        <button 
                                            onClick={handleAllGrant}
                                            className="px-2 py-1 bg-gray-200 border border-gray-300 hover:bg-gray-300 text-xs"
                                        >
                                            전체 지급
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* 단일 멤버 쌀 회수 */}
                    <div className="bg-gray-100 border border-gray-300 p-2">
                        <h2 className="text-xs font-bold mb-2">단일 멤버 쌀 회수</h2>
                        <div className="text-xs text-red-500 mb-2">회수액을 부호없이 입력해 주세요. 입력한 액수만큼 마이너스가 됩니다.</div>
                        <div className="text-xs text-red-500 mb-2">해당 멤버의 쌀 잔액이 회수액보다 적으면 회수가 불가능합니다.</div>
                        <table className="w-full text-xs">
                            <tbody>
                                <tr>
                                    <td className="w-16 py-1">멤버 ID</td>
                                    <td className="py-1">
                                        <input 
                                            type="number" 
                                            value={singleRevokeMemberId}
                                            onChange={(e) => setSingleRevokeMemberId(e.target.value)}
                                            className="w-full border border-gray-300 px-1 py-1"
                                            placeholder="멤버 ID 입력"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="py-1">회수액</td>
                                    <td className="py-1">
                                        <input 
                                            type="number" 
                                            value={singleRevokeAmount}
                                            onChange={(e) => setSingleRevokeAmount(e.target.value)}
                                            className="w-full border border-gray-300 px-1 py-1"
                                            placeholder="회수액"
                                            min="1"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td className="py-1">
                                        <button 
                                            onClick={handleSingleRevoke}
                                            className="px-2 py-1 bg-red-200 border border-gray-300 hover:bg-red-300 text-xs"
                                        >
                                            회수
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default RiceGrantAndRevokeManagementPage;